/**
 * Conversion Prime — Behavioral Event Tracking
 * Fires custom GA4 events for CRO-relevant user interactions on PDPs.
 * Safe to add to any page — only fires on /products/ URLs.
 * Does NOT modify DOM, styles, or page behavior.
 */
(function () {
  'use strict';

  // Only run on product pages
  if (!window.location.pathname.startsWith('/products/')) return;

  var handle = window.location.pathname.replace('/products/', '').split('?')[0].split('/')[0];
  var fired = {};

  function track(name, params) {
    if (fired[name]) return; // Fire once per event per pageview
    fired[name] = true;
    params = params || {};
    params.page_handle = handle;
    params.page_path = window.location.pathname;

    // Use gtag if available (Google channel app)
    if (typeof gtag === 'function') {
      gtag('event', name, params);
    }
    // Fallback: push to dataLayer for GTM
    else if (window.dataLayer) {
      window.dataLayer.push(Object.assign({ event: name }, params));
    }
  }

  // --- SCROLL DEPTH ---
  var scrollThresholds = [25, 50, 75, 90];
  var scrollFired = {};

  function checkScroll() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (docHeight <= 0) return;
    var pct = Math.round((scrollTop / docHeight) * 100);

    for (var i = 0; i < scrollThresholds.length; i++) {
      var t = scrollThresholds[i];
      if (pct >= t && !scrollFired[t]) {
        scrollFired[t] = true;
        track('pdp_scroll_depth', { depth_threshold: t, depth_percent: pct });
      }
    }
  }

  var scrollTimer;
  window.addEventListener('scroll', function () {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(checkScroll, 200);
  }, { passive: true });

  // --- VIDEO PLAY ---
  // Detect click on "Watch the video" button or YouTube embed interaction
  document.addEventListener('click', function (e) {
    var target = e.target;
    var el = target.closest ? target.closest('button, a, [data-video], .deferred-media') : target;
    if (!el) return;

    var text = (el.textContent || '').toLowerCase();
    if (text.indexOf('watch') !== -1 && text.indexOf('video') !== -1) {
      track('pdp_video_play', { trigger: 'watch_button' });
    }
  });

  // --- BNPL / FINANCING CLICK ---
  document.addEventListener('click', function (e) {
    var target = e.target;
    var el = target.closest ? target.closest('a, button, .affirm-as-low-as, [data-affirm], .shopify-payment-terms') : target;
    if (!el) return;

    var text = (el.textContent || '').toLowerCase();
    var classes = (el.className || '').toLowerCase();

    if (classes.indexOf('affirm') !== -1 || text.indexOf('affirm') !== -1 ||
        text.indexOf('qualify') !== -1 || text.indexOf('installment') !== -1 ||
        classes.indexOf('payment-terms') !== -1 || text.indexOf('purchasing power') !== -1) {
      track('pdp_bnpl_click', {
        provider: classes.indexOf('affirm') !== -1 ? 'affirm' : 'shop_pay'
      });
    }
  });

  // --- REVIEW SECTION VIEW ---
  // Fire when reviews section scrolls into viewport
  var reviewsEl = document.getElementById('user-reviews') || document.getElementById('looxReviews');
  if (reviewsEl && 'IntersectionObserver' in window) {
    var reviewObs = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        track('pdp_review_view', { review_section: 'loox' });
        reviewObs.disconnect();
      }
    }, { threshold: 0.3 });
    reviewObs.observe(reviewsEl);
  }

  // --- FREQUENTLY BOUGHT TOGETHER (CROSS-SELL) ---
  var fbtEl = document.querySelector('.product-bundle, [data-product-bundle]');
  if (fbtEl) {
    // Track when FBT section is viewed
    if ('IntersectionObserver' in window) {
      var fbtObs = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          track('pdp_fbt_view', {});
          fbtObs.disconnect();
        }
      }, { threshold: 0.3 });
      fbtObs.observe(fbtEl);
    }

    // Track clicks on FBT items
    fbtEl.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('a') : null;
      if (link) {
        var href = link.getAttribute('href') || '';
        track('pdp_fbt_click', { clicked_product: href });
      }
    });
  }

  // --- SPECIFICATION TAB ---
  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('a, button') : e.target;
    if (!el) return;
    var text = (el.textContent || '').toLowerCase().trim();
    var href = (el.getAttribute('href') || '').toLowerCase();

    if (text === 'specifications' || href === '#specifications') {
      track('pdp_spec_tab', {});
    }
    if (text === 'faqs' || href === '#faq') {
      track('pdp_faq_tab', {});
    }
    if (text === 'our review' || href === '#our-review') {
      track('pdp_review_tab', {});
    }
    if (text === 'description' || href === '#description') {
      track('pdp_description_tab', {});
    }
  });

  // --- FAQ EXPAND ---
  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('.accordion, details, [data-faq], .faq-question') : null;
    if (el) {
      track('pdp_faq_expand', { question: (el.textContent || '').substring(0, 80) });
    }
  });

  // --- CHAT WITH EXPERT ---
  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('a, button') : e.target;
    if (!el) return;
    var text = (el.textContent || '').toLowerCase();
    if ((text.indexOf('chat') !== -1 && text.indexOf('expert') !== -1) ||
        (text.indexOf('need') !== -1 && text.indexOf('help') !== -1)) {
      track('pdp_chat_click', {});
    }
  });

  // --- PRICE MATCH ---
  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('a, button') : e.target;
    if (!el) return;
    var text = (el.textContent || '').toLowerCase();
    if (text.indexOf('better price') !== -1 || text.indexOf('price match') !== -1) {
      track('pdp_price_match_click', {});
    }
  });

  // --- ADD TO CART ---
  // Shopify already tracks this but we want it in our event stream
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.action && form.action.indexOf('/cart/add') !== -1) {
      track('pdp_add_to_cart', { handle: handle });
    }
  });

  // --- TIME ON PAGE ---
  var startTime = Date.now();
  window.addEventListener('beforeunload', function () {
    var duration = Math.round((Date.now() - startTime) / 1000);
    // Only track if they spent at least 5 seconds (filter out bounces)
    if (duration >= 5) {
      // Use sendBeacon for reliability on page exit
      if (navigator.sendBeacon && typeof gtag === 'function') {
        gtag('event', 'pdp_time_on_page', {
          duration_seconds: duration,
          page_handle: handle,
          transport_type: 'beacon'
        });
      }
    }
  });
})();
